import baseScmService from './baseScmService';

const userRolesService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getUserRoles: build.query({
      query: () => ({
        method: 'GET',
        url: 'users-roles',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetUserRolesQuery } = userRolesService;

export default userRolesService;
